import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  fileRow: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 1.5),
  },
  fileIcon: {
    color: theme.palette.text.secondary,
    flexShrink: 0,
    marginRight: theme.spacing(1),
  },
  fileName: {
    fontSize: 13,
    color: theme.palette.text.primary,
    wordBreak: 'break-all',
  },
}))

export default useStyles
